/** Unweighted max/avg from chart row values (stream-derived fallback). */

export function metricStats(data, dataKey, decimals = 0) {
  const values = data.map((d) => d[dataKey]).filter((v) => v != null && !Number.isNaN(v));
  if (!values.length) return { max: null, avg: null };
  const max = Math.max(...values);
  const avg = values.reduce((a, b) => a + b, 0) / values.length;
  const fmt = (v) => (decimals ? Number(v.toFixed(decimals)) : Math.round(v));
  return { max: fmt(max), avg: fmt(avg) };
}
